import React from 'react';
import CheckDimensions from './component';

export default React.memo(CheckDimensions);
